import { ToggleValue } from './../../types/dev/toggler-config';
import { Component, input, computed, signal, OnInit, model } from '@angular/core';
import { BootstrapIcon, TogglerConfig } from '@shared/types/dev';

@Component({
  selector: 'idel-toggler',
  templateUrl: './toggler.component.html',
  styleUrl: './toggler.component.scss',
})
export class TogglerComponent implements OnInit {
  public readonly ngModel = model<boolean>(true);

  public readonly value = input<TogglerConfig<any, any>>();
  public readonly binary = input<boolean>(false);

  public readonly leftValue = computed<ToggleValue<any>>(() => this.value()[0]);
  public readonly rightValue = computed<ToggleValue<any>>(() => this.value()[1]);

  public readonly selectedValue = signal<ToggleValue<any>>({} as ToggleValue<any>);

  ngOnInit(): void {
    this.selectedValue.set(this.value()[0]);
  }

  public isIcon<T>(value: T | BootstrapIcon): value is BootstrapIcon {
    return typeof value === 'string' && value.startsWith('bi');
  }
}
